/// <amd-module name="Feed/Legacy/ControllerViews/ILegacyControllerViewProps" />
import { FeedStore } from "Feed/Legacy/Stores/FeedStore";
import { PackageStore } from "Feed/Legacy/Stores/PackageStore";

export interface ILegacyControllerViewProps {
    feedFluxStore: FeedStore;
    packageFluxStore: PackageStore;
}
